import Dashboard from '../components/dashboard/Dashboard';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

export default function DashboardPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <Dashboard />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
